import { keyboardKey, SpacebarKey } from '../../keyboard-key';
import { IS_FOCUSABLE_ATTRIBUTE } from '../../attributes';
/**
 * @specification
 * Adds role='menuitem'.
 * Adds attribute 'data-is-focusable=true' to 'root' slot.
 * Triggers 'performClick' action with 'Enter' or 'Spacebar' on 'root'.
 */
export var navigableListItemBehavior = function navigableListItemBehavior(props) {
  var _root;
  return {
    attributes: {
      root: (_root = {
        role: 'menuitem'
      }, _root[IS_FOCUSABLE_ATTRIBUTE] = true, _root)
    },
    keyActions: {
      root: {
        performClick: {
          keyCombinations: [{
            keyCode: keyboardKey.Enter
          }, {
            keyCode: SpacebarKey
          }]
        }
      }
    }
  };
};
//# sourceMappingURL=navigableListItemBehavior.js.map
